import { Component, Input, ViewEncapsulation } from '@angular/core';
import { BildungsangebotTerminDetail } from '../../../../model';
import { WeiterbildungsinformationenComponent } from '../detail-inhalt/weiterbildungsinformationen/weiterbildungsinformationen.component';
import { WeiterbildungsinhalteComponent } from '../detail-inhalt/weiterbildungsinhalte/weiterbildungsinhalte.component';
import { ZugangsinformationenComponent } from '../detail-inhalt/zugangsinformationen/zugangsinformationen.component';
import { DetailKachelComponent } from '../detail-kachel/detail-kachel.component';
import { InhaltConfig } from '../detail-inhalt/inhalt-config';
import { htmlZuText } from '../../../../shared/utils/html-zu-text';

@Component({
  selector: 'now-wbsuche-lib-tab-informationen',
  templateUrl: './tab-informationen.component.html',
  encapsulation: ViewEncapsulation.None,
  imports: [
    DetailKachelComponent,
    WeiterbildungsinhalteComponent,
    ZugangsinformationenComponent,
    WeiterbildungsinformationenComponent
  ]
})
export class TabInformationenComponent {
  @Input()
  public termin!: BildungsangebotTerminDetail;

  public collapseStates: {
    weiterbildungsinhalte?: boolean;
    zugang?: boolean;
  } = {};

  private inhaltQuelle?: string;

  private inhaltGewandelt = '';

  private zugangQuelle?: string;

  private zugangGewandelt = '';

  // Wird je Änderungsprüfung mehrfach gelesen, deshalb nur bei geänderter Quelle umwandeln
  get inhaltText(): string {
    if (this.termin.angebot.inhalt !== this.inhaltQuelle) {
      this.inhaltQuelle = this.termin.angebot.inhalt;
      this.inhaltGewandelt = htmlZuText(this.termin.angebot.inhalt);
    }
    return this.inhaltGewandelt;
  }

  // Als Absätze, damit htmlZuText zwischen den Feldern Trenner setzt
  get zugangText(): string {
    const { zugang, anrechnung, zielgruppe } = this.termin.angebot;
    const quelle = [
      zugang && `<p>Zugangsvoraussetzungen: ${zugang}</p>`,
      anrechnung && `<p>Anrechnung: ${anrechnung}</p>`,
      zielgruppe && `<p>Zielgruppe: ${zielgruppe}</p>`
    ].join('');
    if (quelle !== this.zugangQuelle) {
      this.zugangQuelle = quelle;
      this.zugangGewandelt = htmlZuText(quelle);
    }
    return this.zugangGewandelt;
  }

  get inhalteAusklappbar(): boolean {
    return this.inhaltText.length > InhaltConfig.COLLAPSE_MIN_LENGTH;
  }

  // Ein Block ohne Schalter darf nie eingeklappt sein, sonst wäre sein Inhalt unerreichbar.
  get inhalteEingeklappt(): boolean {
    return this.inhalteAusklappbar && this.collapseStates.weiterbildungsinhalte !== false;
  }

  get zugangAusklappbar(): boolean {
    return this.zugangText.length > InhaltConfig.COLLAPSE_MIN_LENGTH;
  }

  get zugangEingeklappt(): boolean {
    return this.zugangAusklappbar && this.collapseStates.zugang !== false;
  }

  get showZugangsinformationen(): boolean {
    const {
      teilnehmerMin,
      teilnehmerMax,
      angebot: { zugang, anrechnung, zielgruppe, behinderungen }
    } = this.termin;
    return (
      !!zugang ||
      !!anrechnung ||
      !!zielgruppe ||
      !!teilnehmerMin ||
      !!teilnehmerMax ||
      behinderungen?.length > 0
    );
  }
}
